
import GeoJSON from 'ol/format/GeoJSON';

import mapOriginal from '../common/client/reducers/map';

import {
    MAP_SET_TEMP_FEATURE
} from '../sagas/map';

export function getTempFeature(state) {
    return state.tempFeature;
}

export function getTempGeometry(state) {
    let feature = getTempFeature(state);
    return (feature)
        ? (new GeoJSON()).writeGeometry(feature.get('geometry'))
        : null;
}

export default function map(state, action) {
    switch (action.type) {

        case MAP_SET_TEMP_FEATURE:
            return {
                ...state,
                tempFeature: action.feature
            };

        default:
            return mapOriginal(state, action);
    }
}
